import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=50e6c0d0&scoped=true&"
import script from "./HeaderNotice.vue?vue&type=script&lang=js&"
export * from "./HeaderNotice.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&id=50e6c0d0&prod&lang=css&"
import style1 from "./HeaderNotice.vue?vue&type=style&index=1&id=50e6c0d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6c0d0",
  null
  
)

export default component.exports